import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { Divider, Table, Drawer } from 'antd';
import dayjs from 'dayjs';
import { toISTDate } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import H3Text from '@Uilib/h3Text';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import UserActions from '@Actions/userActions';
import H3Modal from '@Uilib/H3Modal';
import ViewPurchaseRequest from '@Components/Purchase/PurchaseRequests/ViewPurchaseRequest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import './style.scss';
import PRZText from '../../Common/UI/PRZText';
import ViewPurchaseIndent from '../../Purchase/PurchaseIndent/ViewPurchaseIndent';

const PendingPurchaseIndent = (props) => {
  const { user, pendingActions, getPendingActionsLoading, getPendingActions } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [showPiModal, setShowPiModal] = useState(false);
  const [selectedPurchaseIndent, setSelectedPurchaseIndent] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const [selectedPRForMobile, setSelectedPRForMobile] = useState(null);

  useEffect(() => {
    if (user) {
      getPendingActions('map_pi', 10, currentPage, () => { });
    }
  }, [user, currentPage, getPendingActions]);

  const ListScreenKeys = ({ documentData }) => {
    const record = documentData;
    return [
      { label: 'Purchase Request #', value: `${record?.pi_number}` },
      { label: 'BUSINESS UNIT', value: record?.tenant_info?.tenant_name },
      { label: 'ITEM(S)', value: record?.no_of_items },
      { label: 'STATUS', value: record?.status?.split('_').join(' ')?.toProperCase() },
    ];
  };

  const purchaseRequestColumns = [
    {
      title: '',
      render: (record) => (
        <div className="mobile-list__card">
          <div className="mobile-list__card_header">
            <div className="mobile-list__card_header-left">
              <PRZText text={`${record?.pi_number}`} className="mobile-list__card_item-number" />
            </div>
            <div className="mobile-list__card_header-right">
              <PRZText
                text={Helpers.getStatusColor(record.status).text?.toUpperCase()}
                className="qr__status"
                style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
              />
            </div>
          </div>
          <div className="mobile-list__card_body-left">
            <div className="mobile-list__card_item-details">
              {`Business Unit - ${record.tenant_info?.tenant_name}`}
            </div>
            <div className="mobile-list__card_item-details">
              {`Items - ${record.no_of_items}`}
            </div>
          </div>
          <Divider className="mobile-list__card_divider" />
          <div className="mobile-list__card_footer">
            <div className="mobile-list__card_footer-right">
              <PRZText
                className="mobile-list__card__view-more_wrapper"
                onClick={() => {
                  setSelectedPRForMobile(record);
                  setMoreDetailsDrawer(true);
                }}
                text={(
                  <span className="mobile-list__card__view-more-text_wrapper">
                    <span className="mobile-list__card__view-more-text">More Info</span>
                    <FontAwesomeIcon className="mobile-list__card__view-more-icon" icon={faAnglesRight} />
                  </span>
                )}
              />
            </div>
          </div>
          <Drawer
            open={moreDetailsDrawer}
            width="420px"
            mask
            onClose={() => setMoreDetailsDrawer(false)}
            destroyOnClose
          >
            <div className="custom-drawer__header-wrapper">
              <div className="custom-drawer__header" style={{ width: '370px' }}>
                <H3Text
                  text={`${selectedPRForMobile?.pi_number}`}
                  className="custom-drawer__title"
                />
                <H3Image
                  src={closeIcon}
                  className="custom-drawer__close-icon"
                  onClick={() => setMoreDetailsDrawer(false)}
                />
              </div>
            </div>
            <MoreInfoMobileView
              description={selectedPRForMobile?.description}
              customFields={selectedPRForMobile?.custom_fields}
              fields={ListScreenKeys({ documentData: selectedPRForMobile })}
            />
          </Drawer>
        </div>
      ),
      responsive: ['xs'],
    },
    {
      title: '#',
      render: (record) => <div className="column-number__wrapper">{record?.pi_number}</div>,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'BUSINESS UNIT',
      render: (_, record) => <div className="associated-entity">{record.tenant_info?.tenant_name}</div>,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'ITEM(S)',
      render: (_, record) => <div>{record.no_of_items}</div>,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'STATUS',
      render: (item) => (
        <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>
          {Helpers.getStatusColor(item.status).text}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <div className="list__actions">
          <div
            className="list__actions-button list__actions-button-dark"
            onClick={() => {
              setSelectedPurchaseIndent(record);
              setShowPiModal(true);
            }}
          >
            View
          </div>
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      className: 'list__actions-column',
    },
  ];

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      {`${Number(pendingActions?.pi_approval_count || 0)} Purchase Indents`}
                    </div>
                  </div>
                )}
                loading={getPendingActionsLoading}
                showHeader
                size="small"
                scroll="scroll"
                columns={purchaseRequestColumns}
                rowKey="po_id"
                dataSource={pendingActions?.purchase_indents || []}
                pagination={Number(pendingActions?.pi_approval_count) > 10 ? {
                  defaultCurrent: 1,
                  current: currentPage,
                  total: Number(pendingActions?.pi_approval_count),
                  pageSize: 10,
                  onChange: (page) => {
                    getPendingActions('map_pi', 10, page, () => { });
                    setCurrentPage(page);
                  },
                  position: ['bottomLeft'],
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  showSizeChanger: false,
                } : false}
              />
            </div>
          </div>
        </div>
      </div>

      <H3Modal
        onClose={() => {
          getPendingActions('map_pi', 10, currentPage, () => { });
          setShowPiModal(false);
        }}
        className="pending-pi__view-pi"
        isOpen={showPiModal}
        title={`Purchase Indent #${selectedPurchaseIndent?.pi_number || ''} for ${selectedPurchaseIndent?.tenant_info?.tenant_name}`}
        showHeader
      >
        <ViewPurchaseIndent
          isQuickView
          selectedPIId={selectedPurchaseIndent?.pi_id}
          selectedTenantId={selectedPurchaseIndent?.tenant_info?.tenant_id}
        />
      </H3Modal>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  getPendingActionsLoading: UserReducers.getPendingActionsLoading,
  pendingActions: UserReducers.pendingActions,
});

const mapDispatchToProps = (dispatch) => ({
  getPendingActions: (actionType, limit, page, callback) => dispatch(UserActions.getPendingActions(actionType, limit, page, callback)),
  getPurchaseRequestsSuccess: (purchaseRequests) => dispatch(PurchaseRequestActions.getPurchaseRequestsSuccess(purchaseRequests)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PendingPurchaseIndent);
